var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{class:{ 'table__head--stuck' : _vm.isSticky },attrs:{"id":"sticky"}},[_c('tr',_vm._l((_vm.filters),function(filter){return _c('table-header',{attrs:{"filter":filter}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }